import { ReactNode } from 'react';

import {
  IconCheckSquare,
  IconFilePlusInside,
  IconLightningBolt,
  IconTimerOutline,
} from '@iwoca/icons';
import { Message, Pill } from '@iwoca/orion';

import styles from './OfferCard.module.css';
import { useNumberFormat } from '../../hooks/useNumberFormat';
import { TGetOffersResponse, TOfferPill } from '../../types';

type TProps = {
  probability?: TGetOffersResponse['data']['offers'][number]['probability_of_offer'];
  amount: number;
  productDetails: ReactNode;
  button: ReactNode;
  pills?: TOfferPill[];
  error: string | null;
  confirmedOffer?: boolean;
};

const OfferCard = ({
  amount,
  productDetails,
  button,
  pills,
  error,
  confirmedOffer,
}: TProps) => {
  const { formatCurrency } = useNumberFormat();

  return (
    <section className={styles.container}>
      <div className={styles.groupContainer}>
        <div className={styles.group}>
          <div className={styles.header}>
            <h3 className={styles.heading}>
              {confirmedOffer ? (
                <span>Confirmed offer:</span>
              ) : (
                <span>Applying for:</span>
              )}{' '}
              <span className={styles.offerAmount}>
                {formatCurrency(amount)}
              </span>
            </h3>
            {pills && (
              <div className={styles.pills}>
                {pills.map((pill) => (
                  <div className={styles.pillContainer} key={pill.key}>
                    <Pill variant={pill.variant}>{pill.value}</Pill>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className={styles.group}>{productDetails}</div>
        <div className={styles.group}>
          <div className={styles.loanDetails}>
            {confirmedOffer ? (
              <ul>
                <li className={styles.listContainer}>
                  <IconLightningBolt
                    data-testid="lighningBolt-icon"
                    width={20}
                    height={20}
                    className={styles.listIcon}
                  />
                  Take money now
                </li>
                <li className={styles.listContainer}>
                  <IconCheckSquare
                    data-testid="checkSquare-icon"
                    width={20}
                    height={20}
                    className={styles.listIcon}
                  />
                  No documents required
                </li>
              </ul>
            ) : (
              <ul>
                <li className={styles.listContainer}>
                  <IconTimerOutline
                    data-testid="timerOutline-icon"
                    width={20}
                    height={20}
                    className={styles.listIcon}
                  />
                  Decision in 24 hours
                </li>
                <li className={styles.listContainer}>
                  <IconFilePlusInside
                    data-testid="filePlusInside-icon"
                    width={20}
                    height={20}
                    className={styles.listIcon}
                  />
                  Documents required
                </li>
              </ul>
            )}
          </div>
          <div className={styles.offerCTA}>{button}</div>
          {error && (
            <Message className={styles.error} message={error} type="error" />
          )}
        </div>
      </div>
    </section>
  );
};

export default OfferCard;
